import * as React from 'react'

export const useTableParams = (defaultSortFilters, params, setParams, setSortFilters, setPage) => {
  const [paramsInitialized, setParamsInitialized] = React.useState(false)

  React.useEffect(() => {
    if (paramsInitialized) {
      return
    }
    const { sortField, sortOrder, offset } = params

    if (!sortField || !sortOrder) {
      setParams(defaultSortFilters, true)
      setSortFilters(defaultSortFilters)
    } else {
      setParams({ sortField, sortOrder }, true)
      setSortFilters({ sortField, sortOrder })
    }
    if (offset) {
      setPage(offset / 20)
    }
    setParamsInitialized(true)
  }, [defaultSortFilters, params, paramsInitialized, setParams, setSortFilters, setPage])
}
